import { useEffect, useState } from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { useSelector } from 'react-redux';

function PollResults(props) {
    const resultsFromState = useSelector(state => state.data.pollSubmissionResults);
    const isMobileView = useSelector(state => state.data.isMobileView);
    const [resultData, setResultData] = useState(null);

    const getGraphData = (results, totalResponses) => {
        let graphData = [...results].sort((a,b) => a.display_order - b.display_order);
        return graphData.map(opt => {
            return {
                pct: (opt.responses === 0 || totalResponses === 0) ? 0 : Math.round((opt.responses / totalResponses) * 100),
                name: opt.value
            }
        }
    )};

    useEffect(() => {
        const results = props && props.results ? props.results : resultsFromState;
        const data = results && results.total_responses !== undefined && results.results ?
            getGraphData(results.results, results.total_responses) : null;
        setResultData(data);
    }, [props, resultsFromState]);

    return (
        <div className="poll-graph-container">
            <ResponsiveContainer width="100%" aspect={isMobileView ? 1 : resultData && resultData.length > 4 ? 1 : 2}>
                <BarChart layout="vertical" data={resultData} margin={{ top: 0, right: 30, bottom: 0, left: 0 }} barGap={16}>
                    <XAxis label={{ position: 'bottom' }} type="number" dataKey="pct" unit={'%'} />
                    <YAxis type="category" dataKey="name" tickLine={false} label={{ position: 'left' }} width={120} />
                    <Bar dataKey="pct" fill="#1D428A" unit={'%'} label={{ position: 'right', formatter: lbl => `${lbl}%` }} barSize={24} isAnimationActive={false} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default PollResults;
